/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Announcement } from '../../models/announcement';
import { PostAnnouncementRequest } from '../../models/post-announcement-request';

export interface PostServiceProviderAnnouncement$Params {
      body: PostAnnouncementRequest
}

export function postServiceProviderAnnouncement(http: HttpClient, rootUrl: string, params: PostServiceProviderAnnouncement$Params, context?: HttpContext): Observable<StrictHttpResponse<Announcement>> {
  const rb = new RequestBuilder(rootUrl, postServiceProviderAnnouncement.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Announcement>;
    })
  );
}

postServiceProviderAnnouncement.PATH = '/service-provider/announcements';
